import Select, { GroupBase, Props as ReactSelectProps, StylesConfig } from "react-select";
import { JevisSelectOption, jevisSelectStyles } from "./jevisSelectStyles";

export type { JevisSelectOption };

type AppSelectProps<IsMulti extends boolean = false> = Omit<
  ReactSelectProps<JevisSelectOption, IsMulti, GroupBase<JevisSelectOption>>,
  "styles"
> & {
  size?: "sm" | "md";
  /** Su sfondo scuro (es. PanelHero): controllo bianco e testo leggibile */
  tone?: "default" | "onDark";
  styles?: StylesConfig<JevisSelectOption, IsMulti, GroupBase<JevisSelectOption>>;
  /** Portale nel body — utile dentro modal (default: true) */
  usePortal?: boolean;
  /** z-index del menu in portale (es. sopra modal z-50) */
  menuZIndex?: number;
};

export default function AppSelect<IsMulti extends boolean = false>({
  size = "md",
  tone = "default",
  styles,
  usePortal = true,
  menuZIndex = 9999,
  className = "",
  classNamePrefix = "jevis-select",
  ...props
}: AppSelectProps<IsMulti>) {
  return (
    <Select<JevisSelectOption, IsMulti, GroupBase<JevisSelectOption>>
      className={`jevis-select-wrap ${className}`.trim()}
      classNamePrefix={classNamePrefix}
      styles={{
        ...(jevisSelectStyles(size, tone) as StylesConfig<
          JevisSelectOption,
          IsMulti,
          GroupBase<JevisSelectOption>
        >),
        ...styles,
        menuPortal: (base) => ({ ...base, zIndex: menuZIndex }),
      }}
      menuPortalTarget={usePortal && typeof document !== "undefined" ? document.body : undefined}
      menuPosition={usePortal ? "fixed" : "absolute"}
      {...props}
    />
  );
}
